// Shared date & price formatters — French locale
// Used by ThankYouPage, admin views and any customer-facing recap.

export const formatEventDateFr = (isoDate, timeStr = null) => {
  if (!isoDate) return "";
  // Support both "YYYY-MM-DD" and full ISO. Avoid timezone drift by
  // constructing a local date when only a plain YYYY-MM-DD is passed.
  let dt;
  if (typeof isoDate === "string" && /^\d{4}-\d{2}-\d{2}$/.test(isoDate)) {
    const [y, m, d] = isoDate.split("-").map(Number);
    dt = new Date(y, m - 1, d);
  } else {
    dt = new Date(isoDate);
  }
  if (Number.isNaN(dt.getTime())) return isoDate;

  let dateFr = new Intl.DateTimeFormat("fr-FR", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(dt);
  dateFr = dateFr.charAt(0).toUpperCase() + dateFr.slice(1);
  if (timeStr) {
    return `${dateFr} à ${String(timeStr).replace(":", "h")}`;
  }
  return dateFr;
};

export const formatEventDateShortFr = (isoDate) => {
  if (!isoDate) return "";
  let dt;
  if (typeof isoDate === "string" && /^\d{4}-\d{2}-\d{2}$/.test(isoDate)) {
    const [y, m, d] = isoDate.split("-").map(Number);
    dt = new Date(y, m - 1, d);
  } else {
    dt = new Date(isoDate);
  }
  if (Number.isNaN(dt.getTime())) return isoDate;
  return new Intl.DateTimeFormat("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(dt);
};

export const formatPrice = (value) => {
  if (value == null) return "0€";
  const n = Number(value);
  if (Number.isNaN(n)) return "0€";
  // No decimals when integer, 2 decimals otherwise.
  const isInt = Math.abs(n - Math.round(n)) < 0.005;
  return isInt
    ? `${Math.round(n).toLocaleString("fr-FR")}€`
    : `${n.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}€`;
};
